import i18n from '@shared/i18n';
import { type BreadcrumbItemPropType } from './BreadcrumbItem';

export const defaultBreadcrumb = [
    {
        href: '/',
        name: i18n.gettext('首頁'),
    },
    {
        href: '/',
        name: i18n.gettext('所有商品'),
    },
    {
        href: '/',
        name: i18n.gettext('分類一'),
    },
    {
        href: '/',
        name: i18n.gettext('子分類'),
    },
    {
        href: '/',
        name: i18n.gettext('商品'),
    },
];

export function getBreadcrumbList(product: Product): BreadcrumbItemPropType[] {
    let productCategory = product.categories;

    const result: BreadcrumbItemPropType[] = [
        {
            href: '/',
            name: i18n.gettext('首頁'),
        },
        {
            href: '/browse',
            name: i18n.gettext('所有商品'),
        },
    ];

    while (productCategory.length) {
        // 儲存當前層級的所有分類，每個分類包含名稱和連結
        const categoryItems = productCategory.map((category) => ({
            name: category.name,
            href: `/browse?categoryId=${category.id}`,
        }));

        // 去除重複的分類名稱
        const categoryMap = new Map<string, { name: string; href: string }>();

        for (const item of categoryItems) {
            categoryMap.set(item.name, item);
        }

        const uniqueCategories = Array.from(categoryMap.values());

        // 將處理後的分類加入結果
        if (uniqueCategories.length === 1) {
            // 單分類情況，直接添加
            result.push(uniqueCategories[0]);
        } else if (uniqueCategories.length > 1) {
            // 多分類情況，使用陣列格式儲存各個分類
            result.push({
                href: uniqueCategories[0].href, // 預設連結，實際不會使用
                name: uniqueCategories[0].name, // 預設名稱，實際不會顯示
                nodes: uniqueCategories,
            });
        }

        const tmp = [] as typeof productCategory;

        productCategory.forEach((category) => {
            if (category.next && category.next.length) {
                tmp.push(...category.next);
            }
        });

        productCategory = tmp;
    }

    result.push({
        href: '',
        name: product.name,
    });

    return result;
}
